var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g2, _path14, _path15, _g3, _path16, _path17, _path18, _path19, _path20, _g4, _path21, _path22, _g5, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRobot = function SvgIconRobot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2A52",
    d: "M39.333 67.357c-1.478 1.368 6.647 4.104 6.647 4.104l4.431-9.575s-9.6-.684-9.6-1.368 0 5.471-1.478 6.84M61.489 70.093s7.386 0 5.908-2.052-2.215-7.522-2.215-7.522-5.17 1.368-8.124 1.368c.74 2.052 4.432 8.207 4.432 8.207zM23.48 12.294c-2.455 1.516-2.455 9.095-1.637 10.61.818 1.517 2.456 2.275 4.911 1.517 2.456-.758 4.141-12.507 4.141-12.507s-4.959-1.137-7.415.38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B466D",
    d: "M24.968 25.01c-1.513 0-2.71-.676-3.41-1.972-.457-.845-.647-3.193-.442-5.463.148-1.651.63-4.566 2.188-5.527 2.544-1.57 7.46-.469 7.669-.42l.277.063-.037.263c-.004.03-.432 2.985-1.155 5.994-1.496 6.227-2.78 6.623-3.202 6.754a6.4 6.4 0 0 1-1.887.308zm2.171-13.208c-1.251 0-2.563.171-3.481.738-2.265 1.398-2.312 8.784-1.529 10.233.825 1.528 2.431 2.014 4.525 1.368 1.618-.5 3.22-7.509 3.886-11.997-.572-.11-1.944-.343-3.4-.343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F0F7",
    d: "M22.892 31.244c-.457 17.786-6.14 31.835 27.42 32.214S83.907 45.336 80.6 31.244C76.506 13.81 63.41.208 50.312.545c-14.734.38-27.011 14.78-27.42 30.699"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "iconRobot_svg__a",
    width: 59,
    height: 59,
    x: 22,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.991 54.575c-2.417-10.006-5.71-38.463 7.922-49.544-8.122 5.537-13.747 15.53-14.021 26.213-.457 17.786-6.14 31.835 27.42 32.214 19.573.221 27.74-5.98 30.493-13.982-4.458 12.946-28.165 18.622-47.672 9.923-2.102-.938-3.633-2.715-4.142-4.824"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#iconRobot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.805 28.497 36.913 5.031h43.892z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.805 29.385 35.251 5.031h1.662l43.892 23.466z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.805 30.274 33.59 5.03h1.661l45.554 24.354zM80.805 31.162 31.928 5.032h1.662l47.215 25.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.805 32.05 31.475 5.677l.403-.646h.05l48.877 26.131zM80.805 32.938 31.06 6.343l.415-.666 49.33 26.373zM80.805 33.827 30.645 7.01l.415-.667 49.745 26.595zM80.805 34.715 30.23 7.676l.415-.666 50.16 26.818zM80.805 35.604 29.814 8.342l.416-.666 50.575 27.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.805 36.492 29.4 9.008l.415-.666 50.991 27.262z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.805 37.38 28.983 9.674l.416-.666L80.805 36.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.805 38.268 28.568 10.341l.415-.667L80.805 37.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "m80.805 39.156-52.652-28.15.415-.665 52.237 27.927zM80.805 40.045 27.737 11.673l.416-.666 52.652 28.15zM80.805 40.933 27.322 12.34l.415-.666 53.068 28.372z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.806 41.821 26.906 13.006l.415-.667 53.483 28.594z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.805 42.71 26.491 13.672l.416-.666L80.805 41.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "m80.805 43.598-54.73-29.26.416-.666L80.805 42.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.805 44.486 25.661 15.004l.415-.666 54.73 29.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.805 45.375 25.245 15.67l.416-.667 55.144 29.482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "M80.805 46.262 24.83 16.336l.416-.666 55.56 29.704z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7DFEC",
    d: "m80.805 47.15-56.39-30.147.414-.667 55.976 29.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7DFEC",
    d: "M80.805 48.04 24 17.669l.416-.666 56.39 30.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7DFEC",
    d: "M80.805 48.928 23.583 18.335l.416-.666 56.806 30.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7DFEC",
    d: "M80.805 49.816 23.17 19.002l.415-.667 57.221 30.593zM80.805 50.704 22.753 19.668l.416-.666 57.636 30.814z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7DFEC",
    d: "M80.805 51.592 22.337 20.334l.416-.666 58.052 31.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DEEC",
    d: "M80.805 52.481 21.922 21l.415-.666 58.468 31.259z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DEEB",
    d: "M80.805 53.37 21.507 21.667l.415-.667 58.883 31.481z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DEEB",
    d: "m80.805 53.647-.286.458-59.428-31.772.416-.666 59.298 31.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DEEB",
    d: "m21.092 22.333-.416.666L80.104 54.77l.415-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DDEA",
    d: "m20.676 22.999-.415.666 59.427 31.772.416-.666zM20.26 23.666l-.415.666 59.428 31.772.415-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4DCEA",
    d: "m19.846 24.332-.416.666L78.858 56.77l.415-.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4DCE9",
    d: "m19.43 24.998-.416.666 59.428 31.771.415-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3DBE9",
    d: "m19.014 25.664-.415.666 59.427 31.772.416-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2DBE8",
    d: "m18.6 26.33-.415.666 59.427 31.772.416-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2DAE8",
    d: "m18.184 26.997-.416.666 59.428 31.772.415-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1D9E7",
    d: "m17.768 27.663-.415.666L76.78 60.101l.416-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0D9E6",
    d: "m17.353 28.329-.415.666 59.428 31.772.415-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD8E5",
    d: "m76.366 60.767-.415.666-59.199-31.65v-.49l.186-.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BED7E5",
    d: "m75.95 61.433-.415.666-58.783-31.427v-.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BED6E4",
    d: "m75.535 62.1-.416.665L16.752 31.56v-.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCD5E3",
    d: "m75.12 62.765-.416.666-57.952-30.983v-.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD4E2",
    d: "m74.705 63.431-.193.309h-.894L16.752 33.337v-.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD3E1",
    d: "M71.958 63.74 16.752 34.225v-.889L73.62 63.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9D2E0",
    d: "M70.296 63.739 16.752 35.112v-.888L71.957 63.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7D0DE",
    d: "M68.634 63.74 16.752 36v-.888L70.296 63.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6CFDD",
    d: "m66.973 63.74-50.22-26.85v-.889L68.633 63.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4CEDC",
    d: "M65.311 63.74 16.752 37.778v-.888l50.221 26.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3CCDA",
    d: "M63.65 63.74 16.752 38.665v-.889l48.56 25.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1CAD9",
    d: "M61.989 63.74 16.752 39.554v-.889L63.65 63.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFC8D7",
    d: "M60.327 63.74 16.752 40.442v-.888L61.99 63.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADC7D5",
    d: "M58.666 63.74 16.752 41.33v-.888L60.327 63.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ABC5D3",
    d: "M57.004 63.74 16.752 42.22v-.889L58.666 63.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8C2D1",
    d: "m55.343 63.74-38.59-20.632v-.888l40.251 21.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6C0CF",
    d: "m53.682 63.74-36.93-19.744v-.889l38.59 20.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4BECD",
    d: "M52.02 63.74 16.752 44.883v-.888l36.93 19.743z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1BBCB",
    d: "M50.357 63.74 16.752 45.772v-.888L52.02 63.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EB9C8",
    d: "M48.697 63.74 16.752 46.66v-.889L50.358 63.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BB6C6",
    d: "m47.035 63.738-30.283-16.19v-.888l31.945 17.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98B3C3",
    d: "m45.373 63.74-28.62-15.303v-.888l30.282 16.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95B0C0",
    d: "m43.712 63.74-26.96-14.414v-.889L45.373 63.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91ADBD",
    d: "M42.05 63.74 16.752 50.214v-.888l26.96 14.414z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8EA9BA",
    d: "M40.389 63.739 16.752 51.102v-.889L42.05 63.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8AA6B6",
    d: "M38.728 63.739 16.752 51.99v-.888L40.39 63.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86A2B3",
    d: "M37.066 63.739 16.752 52.878v-.888L38.728 63.74zM16.752 52.878 37.066 63.74H16.752z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2A52",
    d: "M77.15 11.69c2.15.746 3.62 6.503 3.296 7.79s-1.414 2.133-3.417 1.963c-2.002-.169-5.555-8.813-5.555-8.813s3.526-1.684 5.676-.94"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B466D",
    d: "M77.512 21.76q-.248 0-.512-.023c-2.095-.177-5.219-7.53-5.824-9.003l-.102-.248.253-.12c.15-.072 3.678-1.736 5.935-.954 1.39.482 2.33 2.636 2.768 3.877.597 1.7.91 3.529.727 4.256-.359 1.424-1.53 2.213-3.245 2.214m-5.633-8.984a60 60 0 0 0 1.911 4.07c1.983 3.8 2.946 4.275 3.268 4.302 1.69.142 2.755-.458 3.077-1.737.135-.536-.099-2.194-.713-3.939-.672-1.91-1.563-3.222-2.383-3.506-1.67-.579-4.326.453-5.16.81"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2A52",
    d: "M76.376 28.116c-18.008 13.644-47.295 5.401-51.388.095C28.541 6.626 44.96 2.533 51.311 2.147c4.223-.256 21.118 4.48 25.065 25.969"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EFFE4",
    d: "M59.087 19.116c0 2.302 1.649 4.169 3.683 4.169s3.683-1.11 3.683-3.411-2.468-4.927-4.502-4.927-2.865 1.867-2.865 4.17z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2A52",
    d: "m21.691 35.855 5.086.043s2.954 5.47 0 6.839c-2.954 1.368-6.967 2.136-6.967 2.136z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EFFE4",
    d: "M42.716 19.115c0 2.303-1.649 4.17-3.683 4.17s-3.683-1.11-3.683-3.411c0-2.303 2.468-4.927 4.502-4.927s2.865 1.866 2.865 4.169"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F0F7",
    d: "m6.089 43.95 10.797 1.4c2.823.5 5.641-1.66 6.295-4.824.654-3.165-2.312-5.313-3.928-6.636L12.95 29.81"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EFFE4",
    d: "m55.404 22.147-9.004-.758s1.159 9.095 5.081 9.095 3.923-8.337 3.923-8.337"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "iconRobot_svg__b",
    width: 18,
    height: 9,
    x: 6,
    y: 37,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.176 41.37c-1.972.521-5.665.047-9.478-.739l-1.61 3.32 10.797 1.4c2.823.5 5.641-1.66 6.295-4.824.278-1.347-.102-2.508-.752-3.502-1.197 1.864-2.925 3.728-5.253 4.344z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#iconRobot_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "m23.46 37.577-1.03-.55h1.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "m23.46 37.775-1.4-.749h.37l1.03.55zM23.46 37.973l-1.77-.947h.37l1.4.75zM23.46 38.17l-2.141-1.144h.37l1.77.947z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7DFEC",
    d: "m23.46 38.369-2.511-1.342h.37l2.14 1.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7DFEC",
    d: "m23.46 38.566-2.88-1.54h.369l2.51 1.342z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DFEC",
    d: "m23.46 38.764-3.25-1.738h.37l2.88 1.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DEEB",
    d: "m23.46 38.962-3.62-1.936h.37l3.25 1.738z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DEEB",
    d: "m23.46 39.16-3.991-2.134h.37l3.62 1.936z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DDEA",
    d: "m23.46 39.357-4.361-2.33h.37l3.99 2.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4DDEA",
    d: "m23.46 39.555-4.732-2.529h.37l4.362 2.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4DCE9",
    d: "m23.46 39.753-5.102-2.727h.37l4.731 2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3DBE9",
    d: "m23.46 39.952-5.47-2.925h.369l5.1 2.726z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2DBE8",
    d: "m23.46 40.149-5.841-3.123h.37l5.47 2.925z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2DAE7",
    d: "m23.46 40.346-6.212-3.32h.37l5.841 3.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1D9E7",
    d: "m23.46 40.544-6.582-3.518h.37l6.211 3.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0D9E6",
    d: "m23.46 40.742-6.952-3.716h.37l6.581 3.518z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD8E6",
    d: "m23.46 40.94-7.322-3.914h.37l6.951 3.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD7E5",
    d: "m23.46 41.138-7.692-4.112h.37l7.321 3.915z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BED6E4",
    d: "m23.46 41.336-8.063-4.31h.37l7.692 4.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDD6E3",
    d: "m23.46 41.534-8.432-4.508h.37l8.062 4.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCD5E3",
    d: "m23.46 41.731-8.802-4.705h.37l8.431 4.508z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD4E2",
    d: "m23.46 41.93-9.172-4.904h.37l8.801 4.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD3E1",
    d: "m23.46 42.128-9.542-5.102h.37l9.171 4.904z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2E0",
    d: "m23.46 42.325-9.913-5.299h.37l9.542 5.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9D2DF",
    d: "m23.46 42.523-10.282-5.496h.37l9.912 5.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D1DF",
    d: "m23.46 42.72-10.653-5.694h.37l10.282 5.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7D0DE",
    d: "m23.459 42.781-.064.103-10.957-5.858h.369l10.652 5.694z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6CFDD",
    d: "m23.395 42.885-.092.148-11.235-6.007h.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5CEDC",
    d: "m23.303 43.033-.093.148-11.513-6.155h.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4CDDB",
    d: "m23.21 43.181-.093.149-11.79-6.304h.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3CCDA",
    d: "m23.118 43.33-.093.148-12.068-6.452h.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2CBD9",
    d: "m23.025 43.478-.093.148-12.345-6.6h.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1CAD8",
    d: "m22.933 43.626-.093.149-12.623-6.749h.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFC9D7",
    d: "m22.84 43.775-.093.148-12.9-6.897h.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEC8D6",
    d: "m22.747 43.923-.092.148-13.1-7.002.027-.043h.265z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADC7D5",
    d: "m9.556 37.068-.093.148 13.099 7.003.092-.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACC6D5",
    d: "m9.464 37.217-.093.148 13.099 7.003.092-.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ABC5D4",
    d: "m9.37 37.365-.092.149 13.099 7.003.093-.149z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAC4D3",
    d: "m9.278 37.513-.092.149 13.099 7.003.092-.149z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9C3D1",
    d: "m9.185 37.662-.092.148 13.099 7.003.092-.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8C1D0",
    d: "M9.093 37.81 9 37.958 22.1 44.963l.092-.149z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6C0CF",
    d: "m9 37.959-.092.148 13.099 7.003.092-.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5BFCE",
    d: "m8.908 38.107-.093.148 13.099 7.003.092-.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4BECD",
    d: "m8.816 38.255-.093.149 13.099 7.003.092-.149z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3BDCC",
    d: "m8.723 38.403-.093.149 13.099 7.003.092-.149z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1BCCB",
    d: "m8.63 38.552-.092.148 13.099 7.003.092-.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0BBCA",
    d: "m21.637 45.703-.092.148-13.1-7.002.093-.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9FB9C9",
    d: "M21.174 45.852 8.353 38.998l.092-.148 13.1 7.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EB8C8",
    d: "M20.804 45.852 8.26 39.146l.093-.148 12.821 6.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9CB7C7",
    d: "M20.434 45.851 8.168 39.294l.092-.149 12.544 6.706z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BB6C5",
    d: "M20.063 45.851 8.075 39.442l.093-.148 12.266 6.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AB4C4",
    d: "m19.694 45.852-11.71-6.26.091-.15 11.989 6.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98B3C3",
    d: "M19.323 45.852 7.891 39.739l.093-.148 11.71 6.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97B2C2",
    d: "M18.954 45.852 7.798 39.887l.093-.148 11.432 6.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96B1C1",
    d: "M18.584 45.852 7.706 40.037l.092-.15 11.156 5.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94AFC0",
    d: "m18.213 45.851-10.6-5.667.093-.148 10.878 5.815z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93AEBE",
    d: "M17.843 45.851 7.521 40.332l.092-.148 10.6 5.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92ADBD",
    d: "m17.473 45.852-10.045-5.37.093-.15 10.322 5.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90ABBC",
    d: "M17.103 45.851 7.336 40.63l.092-.148 10.045 5.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FAABB",
    d: "m16.733 45.852-9.49-5.074.093-.149 9.767 5.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8DA9B9",
    d: "M16.363 45.851 7.15 40.926l.093-.148 9.49 5.073z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CA7B8",
    d: "m15.993 45.852-8.935-4.778.093-.148 9.212 4.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8AA6B7",
    d: "m15.623 45.851-8.658-4.628.093-.149 8.935 4.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89A5B6",
    d: "m15.253 45.852-8.38-4.48.093-.148 8.657 4.628z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87A3B4",
    d: "M14.883 45.852 6.78 41.52l.092-.148 8.38 4.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86A2B3",
    d: "m14.513 45.851-7.825-4.183.092-.148 8.103 4.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86A2B3",
    d: "m6.089 42.63.599-.962 7.825 4.184H6.089z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#BECEDE",
    d: "M15.574 37.458c.882-4.266-1.49-8.27-5.295-8.945-3.806-.674-7.606 2.238-8.487 6.504s1.49 8.27 5.295 8.945c3.806.674 7.606-2.238 8.487-6.504"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "iconRobot_svg__c",
    width: 15,
    height: 17,
    x: 1,
    y: 28,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.378 37.591c.882-4.266-1.49-8.27-5.295-8.945-3.806-.674-7.606 2.238-8.487 6.504s1.49 8.27 5.295 8.945c3.806.674 7.606-2.238 8.487-6.504"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#iconRobot_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "m16.26 33.018-5.447-5.044h5.447zM16.26 33.17l-5.612-5.196h.165l5.447 5.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "m16.26 33.324-5.778-5.35h.166l5.612 5.197zM16.26 33.476l-5.943-5.502h.165l5.778 5.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8DFEC",
    d: "m16.26 33.63-6.108-5.656h.166l5.942 5.502z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7DFEC",
    d: "m16.26 33.782-6.273-5.808h.165l6.108 5.656zM16.26 33.935l-6.438-5.961h.165l6.273 5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7DFEC",
    d: "m16.26 34.088-6.604-6.114h.165l6.438 5.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DEEB",
    d: "M16.26 34.241 9.49 27.974h.166l6.603 6.115z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DEEB",
    d: "m16.26 34.394-6.934-6.42h.165l6.769 6.267z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DDEA",
    d: "M16.26 34.547 9.16 27.974h.165l6.934 6.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DDEA",
    d: "m16.26 34.7-7.264-6.726h.165l7.099 6.573z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DDEA",
    d: "m16.26 34.853-7.429-6.88h.165L16.26 34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4DCE9",
    d: "m16.26 35.006-7.595-7.032h.166l7.429 6.879zM16.26 35.16 8.5 27.975h.166l7.594 7.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3DBE8",
    d: "m16.26 35.312-7.925-7.338h.166l7.759 7.185z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3DBE8",
    d: "m16.26 35.465-8.09-7.491h.165l7.925 7.337z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3DAE7",
    d: "m16.26 35.617-8.255-7.643h.165l8.09 7.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2DAE6",
    d: "m16.26 35.77-8.42-7.796h.165l8.255 7.643z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1D9E6",
    d: "m16.26 35.923-8.586-7.95h.166l8.42 7.797z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1D9E5",
    d: "m16.26 36.077-8.75-8.103h.164l8.586 7.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0D8E5",
    d: "m16.26 36.23-8.915-8.256h.165l8.75 8.103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0D7E4",
    d: "m16.26 36.382-9.081-8.408h.166l8.914 8.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD7E3",
    d: "m16.26 36.535-9.246-8.561h.165l9.08 8.408z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD6E3",
    d: "m16.26 36.688-9.411-8.714h.165l9.246 8.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BED5E2",
    d: "m16.26 36.84-9.576-8.866h.165l9.41 8.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDD5E1",
    d: "m16.26 36.994-9.742-9.02h.166l9.576 8.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDD4E1",
    d: "m16.26 37.147-9.907-9.173h.165l9.742 9.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCD3E0",
    d: "M16.26 37.3 6.188 27.973h.165l9.907 9.173z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCD3DF",
    d: "m16.26 37.453-10.237-9.48h.165L16.259 37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD2DF",
    d: "M16.26 37.605 5.858 27.974h.165l10.237 9.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD1DE",
    d: "M16.26 37.759 5.692 27.974h.166l10.401 9.631z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD1DD",
    d: "M16.26 37.911 5.528 27.974h.165l10.567 9.785z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9D0DC",
    d: "M16.26 38.065 5.362 27.974h.166L16.26 37.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8CFDC",
    d: "M16.26 38.217 5.198 27.974h.164l10.898 10.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8CEDB",
    d: "M16.26 38.37 5.104 28.04l.072-.066h.021L16.26 38.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7CEDA",
    d: "M16.26 38.524 5.02 28.117l.083-.077 11.155 10.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6CDD9",
    d: "M16.26 38.676 4.937 28.192l.083-.076L16.26 38.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5CCD9",
    d: "M16.26 38.829 4.856 28.269l.083-.077 11.32 10.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5CBD8",
    d: "M16.26 38.982 4.774 28.346l.082-.077 11.404 10.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4CBD7",
    d: "M16.26 39.136 4.69 28.423l.083-.077L16.26 38.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3CAD6",
    d: "M16.26 39.289 4.608 28.499l.083-.076L16.26 39.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9D5",
    d: "M16.26 39.442 4.525 28.576l.083-.077 11.652 10.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2C8D4",
    d: "M16.26 39.594 4.443 28.652l.082-.076L16.26 39.442z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1C7D4",
    d: "M16.26 39.746 4.36 28.728l.083-.077L16.26 39.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0C6D3",
    d: "M16.26 39.9 4.278 28.804l.082-.075 11.9 11.017z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFC6D2",
    d: "M16.26 40.053 4.196 28.882l.082-.077L16.26 39.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEC5D1",
    d: "M16.26 40.206 4.112 28.958l.083-.077L16.26 40.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEC4D0",
    d: "M16.26 40.359 4.03 29.034l.083-.076L16.26 40.206z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADC3CF",
    d: "M16.26 40.512 3.946 29.11l.083-.076 12.23 11.324z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACC2CE",
    d: "m16.26 40.64-.014.012-12.38-11.466.081-.076L16.26 40.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ABC1CD",
    d: "m3.865 29.187-.083.077 12.382 11.465.082-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAC0CC",
    d: "m3.783 29.263-.083.077 12.381 11.465.083-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9BFCB",
    d: "m3.7 29.34-.083.076L16 40.881l.082-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8BECA",
    d: "m3.617 29.417-.082.077 12.381 11.465.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8BECA",
    d: "m3.535 29.494-.082.076 12.381 11.466.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7BDC9",
    d: "m3.452 29.57-.083.076 12.382 11.466.082-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6BCC8",
    d: "m3.37 29.646-.083.077 12.381 11.465.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5BBC7",
    d: "m3.287 29.722-.083.077 12.381 11.465.083-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4BAC6",
    d: "m3.205 29.8-.083.076 12.382 11.465.082-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3B9C5",
    d: "m3.122 29.875-.083.076 12.382 11.466.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2B8C4",
    d: "m3.04 29.951-.083.077 12.381 11.465.083-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1B7C3",
    d: "m2.957 30.028-.082.077L15.256 41.57l.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0B6C2",
    d: "m2.874 30.105-.082.077 12.381 11.465.083-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9FB5C1",
    d: "m2.791 30.18-.082.077L15.09 41.723l.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9FB4C0",
    d: "m2.709 30.257-.083.077 12.382 11.465.082-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EB3BF",
    d: "m2.627 30.334-.083.077 12.382 11.465.082-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9DB2BD",
    d: "m2.544 30.41-.083.076 12.382 11.466.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9CB1BC",
    d: "m2.461 30.487-.082.077L14.76 42.029l.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BB0BB",
    d: "m2.378 30.564-.082.077 12.381 11.465.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AAFBA",
    d: "m2.296 30.64-.082.077 12.381 11.465.083-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99AEB9",
    d: "m2.214 30.716-.083.076 12.381 11.466.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98ADB8",
    d: "m2.13 30.794-.082.076L14.43 42.336l.082-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97ACB7",
    d: "m2.049 30.87-.083.076L14.348 42.41l.082-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96ABB6",
    d: "m1.966 30.946-.083.076 12.382 11.466.082-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95A9B5",
    d: "m1.883 31.022-.082.077 12.381 11.465.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94A8B4",
    d: "m1.8 31.099-.082.076 12.381 11.466.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93A7B3",
    d: "m1.718 31.175-.082.077 12.381 11.465.083-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92A6B1",
    d: "m1.636 31.252-.083.076 12.382 11.466.082-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91A5B0",
    d: "m1.553 31.329-.083.076 12.382 11.466.082-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90A4AF",
    d: "m1.47 31.404-.083.077L13.77 42.946l.083-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FA3AE",
    d: "m1.388 31.482-.083.076 12.382 11.465.083-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8DA2AD",
    d: "m1.305 31.557-.082.076L13.604 43.1l.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CA1AC",
    d: "m1.223 31.634-.083.077L13.52 43.176l.083-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BA0AB",
    d: "m1.14 31.712-.082.076 12.381 11.466.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8A9EA9",
    d: "m1.057 31.788-.082.076L13.356 43.33l.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#899DA8",
    d: "m.975 31.863-.083.077 12.382 11.465.082-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#889CA7",
    d: "m.892 31.94-.083.077 12.382 11.465.083-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#879BA6",
    d: "m.81 32.017-.083.076L13.11 43.56l.083-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#869AA5",
    d: "m13.109 43.559-.083.076-12.312-11.4v-.13l.013-.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8599A3",
    d: "m13.026 43.635-.082.076L.713 32.386v-.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8497A2",
    d: "m12.944 43.711-.083.077L.714 32.54v-.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8396A1",
    d: "m12.86 43.788-.081.077L.714 32.693v-.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8295A0",
    d: "m12.779 43.865-.083.076L.714 32.846v-.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80949F",
    d: "m12.696 43.94-.083.078L.714 32.998v-.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F939D",
    d: "m12.613 44.017-.082.077L.714 33.152v-.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7E919C",
    d: "m12.531 44.093-.083.077L.714 33.304v-.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D909B",
    d: "m12.448 44.17-.083.076L.714 33.458v-.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C8F9A",
    d: "m12.366 44.247-.083.076L.714 33.611v-.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B8E98",
    d: "m12.283 44.324-.082.076L.714 33.763v-.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A8D97",
    d: "m12.2 44.4-.082.076L.714 33.916v-.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#788B96",
    d: "m12.118 44.477-.083.076L.715 34.07v-.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#778A95",
    d: "m12.035 44.552-.083.077L.714 34.222v-.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#768993",
    d: "m11.952 44.63-.082.076L.714 34.376v-.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#758892",
    d: "m11.87 44.706-.072.066h-.022L.714 34.528v-.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#748691",
    d: "M11.611 44.772.714 34.681v-.153l11.062 10.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73858F",
    d: "M11.446 44.772.714 34.834v-.153L11.61 44.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#71848E",
    d: "M11.28 44.772.715 34.987v-.153l10.733 9.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70838D",
    d: "M11.116 44.772.714 35.139v-.152l10.567 9.785z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F818B",
    d: "M10.95 44.772.714 35.293v-.153l10.402 9.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E808A",
    d: "M10.786 44.772.714 35.445v-.153l10.237 9.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D7F89",
    d: "M10.62 44.772.714 35.6v-.153l10.072 9.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B7D87",
    d: "m10.456 44.772-9.742-9.02v-.153l9.906 9.173z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A7C86",
    d: "M10.29 44.772.714 35.905v-.154l9.741 9.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#697B85",
    d: "m10.125 44.772-9.41-8.715v-.152l9.575 8.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#687A83",
    d: "M9.96 44.772.714 36.21v-.154l9.411 8.715z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#667882",
    d: "M9.795 44.772.714 36.363v-.153l9.246 8.562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#657781",
    d: "M9.63 44.773.714 36.517v-.153l9.08 8.409z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64767F",
    d: "M9.464 44.773.714 36.67v-.153l8.916 8.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63747E",
    d: "m9.3 44.772-8.586-7.95v-.153l8.75 8.103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61737D",
    d: "m9.134 44.772-8.42-7.797v-.154l8.585 7.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#60727B",
    d: "M8.969 44.772.714 37.128v-.153l8.42 7.797z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F707A",
    d: "M8.803 44.772.714 37.28v-.154l8.255 7.645z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E6F78",
    d: "M8.638 44.772.714 37.433v-.152l8.09 7.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C6E77",
    d: "m8.474 44.772-7.76-7.185v-.153l7.925 7.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B6C76",
    d: "M8.308 44.772.714 37.74v-.153l7.76 7.185z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A6B74",
    d: "m8.144 44.772-7.43-6.879v-.153l7.594 7.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#586973",
    d: "M7.978 44.772.714 38.046v-.153l7.43 6.879z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#576871",
    d: "M7.813 44.773.714 38.199v-.153l7.264 6.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#566770",
    d: "m7.648 44.772-6.934-6.42v-.154l7.1 6.574z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55656F",
    d: "M7.483 44.772.714 38.504v-.152l6.933 6.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#53646D",
    d: "M7.317 44.772.714 38.657v-.153l6.768 6.268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52626C",
    d: "M7.152 44.772.714 38.81v-.152l6.603 6.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#51616A",
    d: "M6.987 44.772.714 38.963v-.153l6.438 5.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F6069",
    d: "M6.822 44.771.714 39.115v-.152l6.273 5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E5E67",
    d: "M6.657 44.772.714 39.269v-.153l6.108 5.656z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D5D66",
    d: "m6.491 44.772-5.777-5.35v-.152l5.943 5.502z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B5B64",
    d: "M6.327 44.772.714 39.575v-.153l5.777 5.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A5A63",
    d: "M6.161 44.772.714 39.728v-.152l5.613 5.196zM.714 39.729l5.447 5.044H.714z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2A52",
    d: "M6.467 28.717S5.728 23.93 9.42 23.93s2.954 7.523 2.954 7.523 2.215 8.89-2.954 10.942-7.902-1.492-8.862-2.736c-.938-1.215-.198-6.808.739-9.574.662-1.958 5.169-1.369 5.169-1.369z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B466D",
    d: "M4.061 42.305q-.151 0-.315-.005c-.176-.005-.315-.142-.31-.305s.15-.29.33-.286c1.567.047 1.962-.27 2.06-.464.292-.586-.937-1.843-1.461-2.38a6 6 0 0 1-.37-.398l-.004-.004a.28.28 0 0 1 .075-.412.34.34 0 0 1 .387.011c.303.07 1.586-.138 1.988-.812.465-.775-.392-2.016-2.41-3.493a.283.283 0 0 1-.082-.374.33.33 0 0 1 .383-.138c3.245 1.022 4.051.673 4.247.475.189-.19.08-.543-.044-.806-.506-1.065-1.95-2.192-2.438-2.192-.176 0-.319-.132-.319-.295s.143-.296.319-.296c.917 0 2.506 1.458 3.022 2.546.365.766.163 1.208-.07 1.444-.506.51-1.647.542-3.473.095 1.268 1.135 1.799 2.125 1.58 2.951-.28 1.058-1.617 1.373-2.02 1.444l-.138.022c.765.789 1.844 1.983 1.405 2.86-.272.545-1.04.81-2.344.81z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2A52",
    d: "M80.82 31.642s6.018 4.302 6.396 6.21c.377 1.907-3.894.815-3.894.815l-2.97-2.888z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F0F7",
    d: "M84.964 35.214c1.478.684 5.17 2.736 3.693 6.84s-5.644 5.81-5.644 5.81l-4.787-9.872s5.262-3.461 6.738-2.777"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "iconRobot_svg__d",
    width: 9,
    height: 11,
    x: 81,
    y: 37,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M88.372 37.987c-.847 3.28-3.79 5.666-6.774 6.956l1.416 2.92s4.167-1.707 5.644-5.81c.607-1.687.34-3.026-.286-4.066"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#iconRobot_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "m89.265 38.465-.893-.478h.893z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "m89.264 38.626-1.194-.64h.301l.893.479zM89.265 38.787l-1.496-.8h.301l1.195.64zM89.264 38.948l-1.796-.961h.301l1.495.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7DFEC",
    d: "m89.264 39.108-2.097-1.121h.3l1.797.96zM89.265 39.27l-2.4-1.283h.302l2.098 1.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DFEC",
    d: "m89.264 39.43-2.699-1.443h.3l2.4 1.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DEEB",
    d: "m89.264 39.591-3-1.604h.301l2.7 1.443z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DEEB",
    d: "m89.264 39.752-3.301-1.765h.301l3 1.604z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DDEA",
    d: "m89.265 39.914-3.603-1.927h.301l3.302 1.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4DDEA",
    d: "m89.264 40.074-3.747-2.003.053-.084h.092l3.602 1.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4DCE9",
    d: "m89.265 40.236-3.822-2.044.074-.12 3.748 2.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3DBE9",
    d: "m89.265 40.396-3.898-2.084.076-.12 3.822 2.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2DBE8",
    d: "m89.264 40.558-3.972-2.124.075-.121 3.897 2.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2DAE7",
    d: "m89.264 40.718-4.047-2.165.075-.12 3.972 2.124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1D9E7",
    d: "m89.264 40.879-4.123-2.204.076-.121 4.047 2.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0D9E6",
    d: "m89.265 41.04-4.2-2.244.076-.121 4.123 2.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD8E6",
    d: "m89.264 41.2-4.274-2.284.076-.12 4.198 2.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD7E5",
    d: "m89.264 41.362-4.348-2.325.074-.121 4.274 2.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BED6E4",
    d: "m89.265 41.524-4.425-2.366.076-.12 4.349 2.325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDD6E3",
    d: "m89.264 41.684-4.5-2.406.076-.12 4.424 2.365z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCD5E3",
    d: "M89.264 41.845 84.69 39.4l.075-.12 4.5 2.405z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD4E2",
    d: "m89.264 42.005-4.65-2.486.076-.12 4.574 2.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD3E1",
    d: "m89.264 42.166-4.725-2.525.076-.121 4.65 2.485z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2E0",
    d: "m89.264 42.327-4.8-2.566.075-.12 4.725 2.525z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9D2DF",
    d: "m89.264 42.488-4.875-2.606.075-.121 4.8 2.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D1DF",
    d: "m89.264 42.648-4.95-2.646.075-.12 4.875 2.606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7D0DE",
    d: "m89.264 42.81-5.026-2.687.075-.12 4.951 2.646z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6CFDD",
    d: "m89.264 42.972-5.1-2.727.074-.121 5.026 2.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5CEDC",
    d: "m89.264 43.132-5.176-2.768.075-.12 5.101 2.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4CDDB",
    d: "m89.264 43.293-5.252-2.807.076-.121 5.176 2.768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3CCDA",
    d: "m89.265 43.399-.026.041-5.301-2.834.074-.12 5.252 2.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2CBD9",
    d: "m83.937 40.606-.075.12 5.3 2.834.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1CAD8",
    d: "m83.862 40.727-.075.12 5.3 2.834.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFC9D7",
    d: "m83.786 40.848-.075.12 5.301 2.834.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEC8D6",
    d: "m83.71 40.968-.074.12 5.3 2.835.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADC7D5",
    d: "m83.636 41.09-.075.12 5.3 2.834.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACC6D5",
    d: "m83.56 41.21-.075.12 5.301 2.834.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ABC5D4",
    d: "m83.486 41.33-.076.121 5.301 2.834.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAC4D3",
    d: "m83.41 41.451-.075.12 5.301 2.835.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9C3D1",
    d: "m83.335 41.572-.075.12 5.3 2.834.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8C1D0",
    d: "m83.26 41.693-.076.12 5.301 2.834.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6C0CF",
    d: "m83.184 41.814-.075.12 5.3 2.834.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5BFCE",
    d: "m83.109 41.934-.075.12 5.3 2.835.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4BECD",
    d: "m83.033 42.054-.075.12 5.301 2.835.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3BDCC",
    d: "m82.959 42.176-.076.12 5.301 2.834.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1BCCB",
    d: "m82.884 42.297-.075.12 5.3 2.834.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0BBCA",
    d: "m82.808 42.417-.075.12 5.3 2.834.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9FB9C9",
    d: "m82.733 42.538-.076.12 5.301 2.835.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EB8C8",
    d: "m82.657 42.659-.075.12 5.3 2.834.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9CB7C7",
    d: "m82.583 42.779-.075.12 5.3 2.834.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BB6C5",
    d: "m82.507 42.9-.075.12 5.3 2.834.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AB4C4",
    d: "m82.432 43.021-.075.12 5.3 2.835.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98B3C3",
    d: "m82.357 43.141-.075.12 5.3 2.835.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97B2C2",
    d: "m82.281 43.262-.075.12 5.3 2.835.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96B1C1",
    d: "m82.206 43.384-.075.12 5.3 2.834.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94AFC0",
    d: "m82.13 43.504-.075.12 5.3 2.834.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93AEBE",
    d: "m82.056 43.624-.075.12 5.3 2.835.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92ADBD",
    d: "m81.98 43.745-.075.12 5.301 2.834.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90ABBC",
    d: "m81.905 43.866-.075.12 5.3 2.834.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FAABB",
    d: "m81.83 43.987-.075.12 5.3 2.834.075-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8DA9B9",
    d: "m81.754 44.107-.075.12 5.3 2.834.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CA7B8",
    d: "m81.679 44.228-.075.12 5.3 2.835.076-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8AA6B7",
    d: "m86.906 47.183-.076.12-5.232-2.797v-.147l.006-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89A5B6",
    d: "m86.83 47.303-.076.121-5.156-2.757v-.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87A3B4",
    d: "m86.754 47.424-.075.12-5.081-2.717v-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86A2B3",
    d: "m86.679 47.544-.075.121-5.006-2.676v-.161zM86.604 47.666l-.124.198h-4.882V44.99z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#BECEDE",
    d: "M83.486 47.698c1.65-.745 1.846-3.52.437-6.197-1.409-2.679-3.889-4.247-5.539-3.502-1.65.744-1.846 3.518-.437 6.197 1.41 2.678 3.889 4.246 5.539 3.502"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "iconRobot_svg__e",
    width: 8,
    height: 11,
    x: 77,
    y: 37,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.486 47.697c1.65-.744 1.846-3.519.437-6.197s-3.889-4.246-5.539-3.502-1.846 3.519-.437 6.197 3.889 4.247 5.539 3.502"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#iconRobot_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "m85.332 42.103-5.245-4.856h5.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8E0ED",
    d: "m85.332 42.173-5.32-4.926h.075l5.245 4.856z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DEEB",
    d: "m85.332 42.244-5.396-4.997h.076l5.32 4.927z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4DCE9",
    d: "m85.332 42.313-5.47-5.066h.074l5.396 4.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3DAE7",
    d: "m85.332 42.382-5.546-5.135h.076l5.47 5.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1D8E5",
    d: "m85.332 42.453-5.621-5.206h.075l5.546 5.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD6E3",
    d: "m85.332 42.521-5.697-5.274h.075l5.622 5.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDD5E1",
    d: "m85.332 42.592-5.772-5.345h.075l5.697 5.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD3DF",
    d: "m85.332 42.661-5.847-5.414h.075l5.772 5.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD1DD",
    d: "m85.332 42.732-5.922-5.485h.075l5.847 5.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8CFDB",
    d: "m85.332 42.8-5.997-5.553h.075l5.922 5.485z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6CDDA",
    d: "m85.332 42.87-6.073-5.623h.076l5.997 5.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5CBD8",
    d: "m85.332 42.94-6.148-5.693h.075l6.073 5.624z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3CAD6",
    d: "m85.332 43.01-6.223-5.763h.075l6.148 5.693z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1C8D4",
    d: "m85.332 43.08-6.298-5.833h.075l6.223 5.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0C6D2",
    d: "m85.332 43.15-6.374-5.903h.076l6.298 5.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEC4D0",
    d: "m85.332 43.219-6.45-5.972h.076l6.374 5.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACC3CF",
    d: "m85.332 43.289-6.524-6.042h.074l6.45 5.972z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ABC1CD",
    d: "m85.332 43.359-6.6-6.112h.076l6.524 6.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9BFCB",
    d: "m85.332 43.428-6.675-6.181h.075l6.6 6.111z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7BDC9",
    d: "m85.332 43.497-6.75-6.25h.075l6.675 6.181z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6BCC8",
    d: "m85.332 43.567-6.825-6.32h.075l6.75 6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4BAC6",
    d: "m85.332 43.637-6.9-6.39h.075l6.825 6.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3B8C4",
    d: "m85.332 43.707-6.975-6.46h.074l6.901 6.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1B7C3",
    d: "m85.332 43.776-7.051-6.53h.075l6.976 6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0B5C1",
    d: "m85.332 43.846-7.126-6.599h.075l7.051 6.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EB4BF",
    d: "m85.332 43.915-7.202-6.668h.076l7.126 6.599z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9DB2BE",
    d: "m85.332 43.985-7.277-6.738h.075l7.202 6.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BB0BC",
    d: "m85.332 44.055-7.352-6.808h.075l7.277 6.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AAFBA",
    d: "m85.332 44.125-7.428-6.878h.076l7.352 6.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98ADB9",
    d: "m85.332 44.194-7.47-6.916.034-.03h.008l7.428 6.877z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97ACB7",
    d: "m85.332 44.264-7.507-6.952.037-.035 7.47 6.917z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95AAB6",
    d: "m85.332 44.334-7.545-6.987.038-.035 7.507 6.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94A9B4",
    d: "m85.332 44.403-7.583-7.021.038-.036 7.545 6.987z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93A7B3",
    d: "m85.332 44.473-7.62-7.057.037-.034 7.583 7.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91A6B1",
    d: "m85.332 44.543-7.658-7.091.038-.035 7.62 7.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90A4B0",
    d: "m85.332 44.612-7.696-7.126.038-.035 7.658 7.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8EA3AE",
    d: "m85.332 44.681-7.733-7.16.037-.035 7.696 7.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8DA1AD",
    d: "m85.332 44.751-7.771-7.196.038-.035 7.733 7.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CA0AB",
    d: "m85.332 44.821-7.808-7.23.037-.036 7.771 7.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8A9FAA",
    d: "m85.332 44.89-7.846-7.265.038-.034 7.808 7.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#899DA8",
    d: "m85.332 44.96-7.884-7.3.038-.034 7.846 7.265z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#889CA7",
    d: "m85.332 45.03-7.921-7.334.037-.036 7.884 7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#879AA5",
    d: "m85.332 45.1-7.96-7.37.039-.035 7.921 7.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8599A4",
    d: "m85.332 45.17-7.997-7.405.038-.035 7.96 7.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8498A3",
    d: "m85.332 45.24-8.034-7.44.037-.034 7.997 7.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8396A1",
    d: "m85.332 45.31-8.072-7.476.038-.034 8.034 7.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8295A0",
    d: "m85.332 45.379-8.11-7.51.038-.035 8.072 7.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80949F",
    d: "m85.332 45.448-8.147-7.544.037-.034 8.11 7.509z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F939D",
    d: "m85.332 45.518-8.185-7.58.038-.034 8.147 7.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7E919C",
    d: "m85.332 45.588-8.222-7.614.037-.035 8.185 7.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D909B",
    d: "m85.332 45.658-8.26-7.649.038-.034 8.222 7.613z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C8F99",
    d: "m85.332 45.728-8.298-7.684.038-.035 8.26 7.649z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B8E98",
    d: "m85.332 45.797-8.335-7.718.037-.035 8.298 7.684z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#798C97",
    d: "m85.332 45.866-8.373-7.753.038-.034 8.335 7.718z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#788B96",
    d: "m85.332 45.936-8.41-7.788.037-.035 8.373 7.754z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#778A94",
    d: "m85.332 46.006-8.448-7.823.037-.035 8.411 7.788z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#768993",
    d: "m85.332 46.075-8.485-7.857.037-.035 8.448 7.823z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#758892",
    d: "m85.332 46.145-8.523-7.893.038-.034 8.485 7.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#748791",
    d: "m85.332 46.215-8.56-7.927.036-.036 8.524 7.893z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#738590",
    d: "m85.332 46.284-8.598-7.962.037-.035 8.561 7.928z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#72848F",
    d: "m85.332 46.354-8.636-7.996.038-.036 8.598 7.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#71838D",
    d: "m85.332 46.424-8.674-8.032.038-.035 8.636 7.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70828C",
    d: "m85.332 46.493-8.712-8.066.038-.035 8.674 8.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F818B",
    d: "m85.332 46.563-8.75-8.1.038-.036 8.712 8.066z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E808A",
    d: "m85.332 46.634-8.786-8.137.037-.035 8.75 8.102z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D7F89",
    d: "m85.332 46.703-8.794-8.143v-.057l.008-.006 8.786 8.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C7E88",
    d: "m85.332 46.772-8.794-8.142v-.07l8.794 8.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B7D87",
    d: "m85.332 46.842-8.794-8.143v-.07l8.794 8.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A7C86",
    d: "m85.332 46.912-8.794-8.144V38.7l8.794 8.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#697B85",
    d: "m85.332 46.98-8.794-8.142v-.07l8.794 8.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#687A84",
    d: "m85.332 47.05-8.794-8.142v-.07l8.794 8.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#677983",
    d: "m85.332 47.12-8.794-8.143v-.069l8.794 8.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#667882",
    d: "m85.332 47.178-.007.006-8.787-8.136v-.07l8.794 8.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#667781",
    d: "m85.325 47.184-.038.035-8.749-8.102v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#657680",
    d: "m85.288 47.218-.038.036-8.712-8.067v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64757F",
    d: "m85.25 47.254-.038.034-8.674-8.032v-.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63757E",
    d: "m85.212 47.289-.037.034-8.637-7.997v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#62747D",
    d: "m85.175 47.323-.038.035-8.599-7.962v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61737D",
    d: "m85.137 47.358-.038.035-8.56-7.928v-.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61727C",
    d: "m85.1 47.393-.038.035-8.524-7.893v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#60717B",
    d: "m85.062 47.428-.037.035-8.487-7.858v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F707A",
    d: "m85.025 47.463-.039.035-8.448-7.823v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E7079",
    d: "m84.986 47.497-.037.036-8.41-7.789v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E6F78",
    d: "m84.95 47.533-.04.034-8.372-7.753v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6E78",
    d: "m84.91 47.567-.036.035-8.336-7.718v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C6D77",
    d: "m84.874 47.602-.038.036-8.298-7.685v-.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B6D76",
    d: "m84.836 47.637-.038.035-8.26-7.649v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B6C75",
    d: "m84.798 47.672-.037.035-8.223-7.614v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A6B75",
    d: "m84.76 47.707-.037.035-8.185-7.58v-.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596A74",
    d: "m84.723 47.742-.038.034-8.147-7.544v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596A73",
    d: "m84.685 47.777-.037.034-8.11-7.509v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#586973",
    d: "m84.648 47.811-.037.035-8.073-7.475v-.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#586872",
    d: "m84.61 47.846-.038.035-8.034-7.44v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#576871",
    d: "m84.572 47.881-.037.035-7.997-7.405v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#566771",
    d: "m84.535 47.916-.037.035-7.96-7.37v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#566770",
    d: "m84.498 47.95-.038.035-7.922-7.335v-.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55666F",
    d: "m84.46 47.986-.038.035-7.884-7.3v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55656F",
    d: "m84.422 48.02-.037.035-7.847-7.265v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54656E",
    d: "m84.385 48.055-.038.035-7.809-7.23v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54646E",
    d: "m84.347 48.09-.038.035-7.77-7.196v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#53646D",
    d: "m84.31 48.125-.039.035L76.538 41v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#53636D",
    d: "m84.271 48.16-.037.035-7.696-7.126v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52636C",
    d: "m84.234 48.195-.037.035-7.659-7.091v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52626C",
    d: "m84.197 48.23-.039.035-7.62-7.057v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#51626B",
    d: "m84.158 48.264-.037.035-7.583-7.021v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#51616B",
    d: "m84.121 48.3-.037.035-7.546-6.988v-.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50616A",
    d: "m84.084 48.334-.038.035-7.508-6.952v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50606A",
    d: "m84.046 48.369-.038.035-7.47-6.917v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#506069",
    d: "m84.008 48.404-.032.03h-.01l-7.428-6.877v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F6069",
    d: "m83.89 48.434-7.352-6.808v-.07l7.428 6.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F5F68",
    d: "m83.815 48.434-7.277-6.738v-.07l7.352 6.808zM83.74 48.435l-7.202-6.669v-.07l7.277 6.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E5E68",
    d: "m83.665 48.434-7.127-6.6v-.068l7.202 6.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E5E67",
    d: "m83.59 48.434-7.052-6.53v-.069l7.127 6.6zM83.515 48.434l-6.977-6.46v-.07l7.051 6.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D5D67",
    d: "m83.44 48.434-6.902-6.39v-.07l6.977 6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D5D66",
    d: "m83.364 48.434-6.826-6.32v-.07l6.901 6.39zM83.288 48.435l-6.75-6.25v-.07l6.826 6.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C5D66",
    d: "m83.213 48.434-6.675-6.181v-.07l6.75 6.251z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C5C65",
    d: "m83.138 48.434-6.6-6.111v-.07l6.675 6.181zM83.062 48.435l-6.524-6.042v-.07l6.6 6.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C5C65",
    d: "m82.988 48.434-6.45-5.971v-.07l6.524 6.041z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C5C65",
    d: "m82.912 48.434-6.374-5.902v-.07l6.45 5.972z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B5B64",
    d: "m82.837 48.434-6.299-5.832v-.07l6.374 5.902z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B5B64",
    d: "m82.762 48.434-6.224-5.762v-.07l6.299 5.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B5B64",
    d: "m82.687 48.434-6.149-5.693v-.07l6.224 5.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B5B64",
    d: "m82.611 48.434-6.073-5.623v-.07l6.148 5.693zM82.536 48.434l-5.998-5.553v-.07l6.073 5.623zM82.461 48.435l-5.923-5.484v-.07l5.998 5.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A5A63",
    d: "m82.385 48.434-5.847-5.415v-.069l5.923 5.484zM82.31 48.434l-5.772-5.345v-.07l5.847 5.415zM82.235 48.435l-5.697-5.275v-.07l5.772 5.345z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A5A63",
    d: "m82.16 48.434-5.622-5.206v-.069l5.697 5.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A5A63",
    d: "m82.084 48.434-5.546-5.136v-.07l5.622 5.206zM82.01 48.435l-5.472-5.066v-.07l5.546 5.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A5A63",
    d: "m81.934 48.435-5.396-4.997v-.07l5.472 5.066z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A5A63",
    d: "m81.859 48.434-5.32-4.927v-.07l5.395 4.997zM81.783 48.434l-5.245-4.857v-.07l5.32 4.927z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A5A63",
    d: "m76.538 43.577 5.245 4.857h-5.245z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2A52",
    d: "M79.215 38.634c-.739-.684-6.559.31-2.954 3.42-2.272.547-2.238 2.957 0 2.735-2.216 1.368-.765 3.12.738 2.735 0 0 5.17.684 5.909-.684-.74-8.206-2.955-7.522-3.693-8.206"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#101B33",
    d: "M53.001 2.185a8 8 0 0 0-1.217-.037c-6.35.385-22.769 4.478-26.321 26.063.59.765 1.705 1.59 3.232 2.403C31.98 13.88 44.877 5.754 53 2.186"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.064 6.774s6.946 14.326 8.524 23.39c7.736-1.316 10.42-4.679 10.42-4.679S69.903 11.16 58.379 5.897c-3 .439-3.315.878-3.315.878",
    opacity: 0.15
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B466D",
    d: "M43.54 67.883h-.01c-.842-.021-3.607-.174-3.786-1.243-.027-.161.093-.312.267-.337s.338.085.365.247c.052.314 1.367.696 3.172.742.176.005.315.14.311.304-.005.16-.147.288-.319.288zM62.951 67.883c-.172 0-.314-.127-.319-.288-.005-.163.134-.3.311-.304 1.804-.046 3.12-.428 3.173-.742.026-.162.19-.271.364-.247.175.024.294.175.267.337-.178 1.07-2.943 1.222-3.786 1.243h-.009"
  })));
};
export { SvgIconRobot as ReactComponent };
export default "/_next/static/media/_/_/packages/frontend/components/assets/iconRobot.aee08cd39dec3075d42d3ad1f7437f4c.svg";